// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-list-container[data-v-2b61a603]{padding-top:2rem}.order-list-container .select-order[data-v-2b61a603]{margin:0 0 1rem 0}.order-list-container button[data-v-2b61a603]{background:#ffcd1c;color:#333;transition:background-color .2s}.order-list-container button[data-v-2b61a603]:hover{background:#ecbe1a}", ""]);
// Exports
module.exports = exports;
